import React, { useState } from "react";
import { Button, Icon, Confirm } from "semantic-ui-react";
import { BasicModal } from "../../Shared";
import { SupportForm } from "../SupportForm";
import { supportAPI } from "../../../api";
import "./SupportItems.scss";

const supportController = new supportAPI();

export function SupportItems(props) {
  const { ticket, onReload, user, accessToken } = props;
  const [showModal, setShowModal] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showMessages, setShowMessages] = useState(false); // Para togglear la vista de mensajes

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  // Cerrar ticket
  const closeTicket = async () => {
    try {
      await supportController.closeTicket(accessToken, ticket._id, {
        userId: user.user._id, // Ajusta según tu lógica
      });
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.log(error);
    }
  };

  // Color del botón "eye" según el estado
  let eyeButtonColor = "grey";
  if (ticket.status === "open") eyeButtonColor = "green";
  if (ticket.status === "closed") eyeButtonColor = "red";
  // Si hay otros estados como "pending", "in-progress", etc., puedes extender la lógica

  return (
    <div className="support-item">
      {/* ENCABEZADO DEL TICKET */}
      <div className="support-item__header">
        <div className="support-item__info">
          <span className="support-item__info-title">{ticket.title}</span>
          <span className="support-item__info-desc">{ticket.description}</span>
          <span className="support-item__info-status">{ticket.status}</span>
        </div>

        <div className="support-item__actions">
          {/* Botón para MOSTRAR/OCULTAR los mensajes */}
          <Button
            icon
            color={eyeButtonColor}
            onClick={() => setShowMessages((prev) => !prev)}
          >
            <Icon name="eye" />
          </Button>

          {/* Botón para responder */}
          {ticket.status !== "closed" && (
            <Button icon primary onClick={onOpenCloseModal}>
              <Icon name="pencil" />
            </Button>
          )}

          {/* Botón para cerrar (solo si eres partner y el ticket está abierto) */}
          {user?.user?.role === "partner" && ticket.status !== "closed" && (
            <Button icon color="red" onClick={onOpenCloseConfirm}>
              <Icon name="ban" />
            </Button>
          )}
        </div>
      </div>

      {/* SECCIÓN DE MENSAJES (tipo "chat") */}
      {showMessages && (
        <div className="support-item__messages">
          {ticket.messages?.map((msg) => {
            // Si el rol del usuario actual coincide con el senderRole, lo consideramos un "my-message"
            const isMyMessage = msg.senderRole === user.user.role;

            return (
              <div
                key={msg._id}
                className={`support-item__message ${
                  isMyMessage ? "my-message" : "other-message"
                }`}
              >
                <div className="support-item__message-sender">
                  <strong>{msg.senderRole}:</strong>
                </div>
                <div
                  className="support-item__message-text"
                  dangerouslySetInnerHTML={{ __html: msg.message }}
                />
              </div>
            );
          })}
        </div>
      )}

      {/* MODAL PARA RESPONDER */}
      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title={`Responder Ticket: ${ticket.title}`}
        size="small"
      >
        <SupportForm
          ticket={ticket}
          onClose={onOpenCloseModal}
          onReload={onReload}
          accessToken={accessToken}
          user={user.user} // Ajusta según tu lógica. A veces es user a secas.
        />
      </BasicModal>

      {/* CONFIRM PARA CERRAR TICKET */}
      <Confirm
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={closeTicket}
        content={`¿Estás seguro de cerrar el ticket: ${ticket.title}?`}
        size="mini"
      />
    </div>
  );
}
